var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantomeChaussuresDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.98 872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ffd93b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fantome 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.45,1377H520.25c-17.52,0-28.53-19.42-19.88-35.08l455.09-824a22.56,22.56,0,0,1,39.69-.14l462.1,824C1466,1357.45,1455,1377,1437.45,1377Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.57,1324.5H603.13c-14.2,0-23.13-15.74-16.12-28.43L955.89,628.14a18.29,18.29,0,0,1,32.17-.11L1362.63,1296C1369.74,1308.65,1360.83,1324.5,1346.57,1324.5Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.17,999.9h75.09s62.74,52.46,85.37,58.63,61.71,0,66.86,14.4,5.14,31.88,5.14,31.88H784.14S771.81,1021,785.17,999.9Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.97,
    y: 460.46,
    width: 222.17,
    height: 66.86
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.97 418.29 587.63 418.29 551.63 454.29 515.63 418.29 539.28 418.29 539.28 382.29 563.97 382.29 563.97 418.29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.65,
    y: 626.09,
    width: 255.49,
    height: 76.88
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.97 750.71 587.63 750.71 551.63 714.71 515.63 750.71 539.28 750.71 539.28 786.71 563.97 786.71 563.97 750.71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantomeChaussuresDanger);
export default __webpack_public_path__ + "static/media/fantome_chaussures_danger.9f4dfdc03aaefd12493ab620a569491c.svg";
export { ForwardRef as ReactComponent };